"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgUpgradeClientIBC = void 0;
var ow_1 = __importDefault(require("ow"));
var typeurl_1 = require("../../../common/constants/typeurl");
var address_1 = require("../../../../utils/address");
var ow_types_1 = require("../../ow.types");
exports.msgUpgradeClientIBC = function (config) {
    return (function () {
        function MsgUpgradeClient(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgUpgradeClientOptions);
            this.clientId = options.clientId;
            this.clientState = options.clientState;
            this.proofUpgradeClient = options.proofUpgradeClient;
            this.proofUpgradeConsensusState = options.proofUpgradeConsensusState;
            this.signer = options.signer;
            this.validateAddresses();
        }
        MsgUpgradeClient.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgUpgradeClient,
                value: {
                    clientId: this.clientId,
                    clientState: this.clientState,
                    proofUpgradeClient: this.proofUpgradeClient,
                    proofUpgradeConsensusState: this.proofUpgradeConsensusState,
                    signer: this.signer,
                },
            };
        };
        MsgUpgradeClient.fromCosmosMsgJSON = function (msgJsonStr) {
            var parsedMsg = JSON.parse(msgJsonStr);
            if (parsedMsg['@type'] !== typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgUpgradeClient) {
                throw new Error("Expected " + typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgUpgradeClient + " but got " + parsedMsg['@type']);
            }
            if (typeof parsedMsg.client_state === 'object' && Object.keys(parsedMsg.client_state).length > 0) {
                throw new Error('IBC MsgUpgradeClient does not support `client_state` decoding.');
            }
            if (typeof parsedMsg.consensus_state === 'object' && Object.keys(parsedMsg.consensus_state).length > 0) {
                throw new Error('IBC MsgUpgradeClient does not support `consensus_state` decoding.');
            }
            return new MsgUpgradeClient({
                clientId: parsedMsg.client_id,
                clientState: null,
                consensusState: null,
                proofUpgradeClient: new Uint8Array(Object.values(parsedMsg.proof_upgrade_client)),
                proofUpgradeConsensusState: new Uint8Array(Object.values(parsedMsg.proof_upgrade_consensus_state)),
                signer: parsedMsg.signer,
            });
        };
        MsgUpgradeClient.prototype.toRawAminoMsg = function () {
            throw new Error('IBC Module not supported under amino encoding scheme');
        };
        MsgUpgradeClient.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.signer,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `signer` does not match network selected');
            }
        };
        return MsgUpgradeClient;
    }());
};
//# sourceMappingURL=MsgUpgradeClient.js.map